const actions = {
  GET_ADDON_CHOICES_BEGIN: 'GET_ADDON_CHOICES_BEGIN',
  GET_ADDON_CHOICES_SUCCESS: 'GET_ADDON_CHOICES_SUCCESS',
  GET_ADDON_CHOICES_ERR: 'GET_ADDON_CHOICES_ERR',

  GET_SINGLE_CHOICE_BEGIN: 'GET_SINGLE_CHOICE_BEGIN',
  GET_SINGLE_CHOICE_SUCCESS: 'GET_SINGLE_CHOICE_SUCCESS',
  GET_SINGLE_CHOICE_ERR: 'GET_SINGLE_CHOICE_ERR',

  ADD_ADDON_CHOICE_BEGIN: 'ADD_ADDON_CHOICE_BEGIN',
  ADD_ADDON_CHOICE_SUCCESS: 'ADD_ADDON_CHOICE_SUCCESS',
  ADD_ADDON_CHOICE_ERR: 'ADD_ADDON_CHOICE_ERR',

  EDIT_ADDON_CHOICE_BEGIN: 'EDIT_ADDON_CHOICE_BEGIN',
  EDIT_ADDON_CHOICE_SUCCESS: 'EDIT_ADDON_CHOICE_SUCCESS',
  EDIT_ADDON_CHOICE_ERR: 'EDIT_ADDON_CHOICE_ERR',

  DELETE_ADDON_CHOICE_BEGIN: 'DELETE_ADDON_CHOICE_BEGIN',
  DELETE_ADDON_CHOICE_SUCCESS: 'DELETE_ADDON_CHOICE_SUCCESS',
  DELETE_ADDON_CHOICE_ERR: 'DELETE_ADDON_CHOICE_ERR',

  getSingleChoiceBegin: () => {
    return {
      type: actions.GET_SINGLE_CHOICE_BEGIN,
    };
  },

  getSingleChoiceSuccess: (data) => {
    return {
      type: actions.GET_SINGLE_CHOICE_SUCCESS,
      data,
    };
  },

  getSingleChoiceErr: (err) => {
    return {
      type: actions.GET_SINGLE_CHOICE_ERR,
      err,
    };
  },

  getAddonChoicesBegin: () => {
    return {
      type: actions.GET_ADDON_CHOICES_BEGIN,
    };
  },

  getAddonChoicesSuccess: (data) => {
    return {
      type: actions.GET_ADDON_CHOICES_SUCCESS,
      data,
    };
  },

  getAddonChoicesErr: (err) => {
    return {
      type: actions.GET_ADDON_CHOICES_ERR,
      err,
    };
  },

  addAddonChoicesBegin: () => {
    return {
      type: actions.ADD_ADDON_CHOICE_BEGIN,
    };
  },

  addAddonChoicesSuccess: (data) => {
    return {
      type: actions.ADD_ADDON_CHOICE_SUCCESS,
      data,
    };
  },

  addAddonChoicesErr: (err) => {
    return {
      type: actions.ADD_ADDON_CHOICE_ERR,
      err,
    };
  },

  editAddonChoicesBegin: () => {
    return {
      type: actions.EDIT_ADDON_CHOICE_BEGIN,
    };
  },

  editAddonChoicesSuccess: (data) => {
    return {
      type: actions.EDIT_ADDON_CHOICE_SUCCESS,
      data,
    };
  },

  editAddonChoicesErr: (err) => {
    return {
      type: actions.EDIT_ADDON_CHOICE_ERR,
      err,
    };
  },

  deleteAddonChoicesBegin: (id) => {
    return {
      type: actions.DELETE_ADDON_CHOICE_BEGIN,
      id,
    };
  },

  deleteAddonChoicesSuccess: (id) => {
    return {
      type: actions.DELETE_ADDON_CHOICE_SUCCESS,
      id,
    };
  },

  deleteAddonChoicesErr: (err) => {
    return {
      type: actions.DELETE_ADDON_CHOICE_ERR,
      err,
    };
  },
};

export default actions;
